<div class="legal-document__block">
  <ul class="legal-document__index-container"
    [ngClass]="{'landing-page__desktop': references.length < 2}">
    @for (reference of references | afOrderBy:['numOrder']:false; track $index) {
      <li (click)="selectReference(reference)"
        class="legal-document__index-reference"
        [ngClass]="{'legal-document__index-reference--selected': reference == legalDocument.selected }">
        <span-tooltip [text]="reference.text"
          [multiline]="2"
          [tooltipPosition]="'top'">
        </span-tooltip>
      </li>
    }
  </ul>
  <div [class]="'legal-document__text-container ' + legalDocument.referenceClass"
    id="legal-document-print">
    <div class="common-section-title__dp-container common-section-title__dp-container--main-100">
      <span class="common-section-title__dp-label-text-medium common-section-title__dp-label-text-medium--main-100">
        {{legalDocument.selected.text}}
      </span>
    </div>
    @if (!legalDocument.error) {
      <div [innerHTML]="legalDocument.selected?.document"
        class="legal-document__document-container">
      </div>
    } @else {
      <div class="common-status-message__g-container-alert">
        <i class="lf-icon-close-round-full common-status-message__icon-md">
        </i>
        <div class="common-status-message__g-content">
          <div class="common-status-message__g-icon-text-content">
            <div class="common-status-message__g-title-subtitle">
              <span class="common-status-message__g-title">
                {{legalDocument.error}}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
